<template>
<section id="company-select">
    <NavbarDefault route="/" />
    <div class="container">
        <div class="row d-flex justify-content-center mb-0">
            <div class="col-11 offset-1">
                <Button @click="$router.go(-1)" size="small" type="outline" color="grey">
                    <ArrowDropdown :rotate="90" /> Voltar
                </Button>
            </div>
        </div>
        <div class="row c-ndarkthree">
            <div class="col-10 offset-1 pt-4">
                <h3 :class="`bold c-${getPrimaryColor}four`">TERMOS E CONDIÇÕES DE USO</h3>
                <h4 :class="`bold c-${getPrimaryColor}four mt-4`">{{ getPartnerName }} — Usuário Fornecedor</h4>
                <div class="d-flex justify-content-center my-4">
                    <table id="terms-of-use-table" class="mt-4">
                        <tbody>
                            <tr v-for="info of tableInfo" :key="info.rowValue">
                                <th class="regular">{{ info.rowHead }}</th>
                                <td class="regular">{{ info.rowValue }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p class="regular">
                    {{
                        `O presente Termo rege o acesso e utilização, no Brasil, à Plataforma oferecida pela ${getPartnerName}, a qual emprega soluções de tecnologia que permite aos Fornecedores, representados por seus Usuários, o acesso a Serviços diversos.`
                    }}
                </p>
                <div class="mt-4 pb-4 c-ndarkthree">
                    <div v-for="(topic, index) of termsTopics" :key="topic" class="mt-5">
                        <h5 class="c-ndarkthree">
                            {{ `${index + 1}. ${topic}` }}
                        </h5>
                        <p v-for="info of termsInfos[index]" :key="info.index" class="my-4">
                            <span class="bold">{{ info.index }}. {{ info.title && `${info.title}:`}}</span>
                            {{ info.content }}
                        </p>
                    </div>
                    <div>
                        <p class="my-4">{{ `A ${getPartnerName} poderá alterar, a qualquer tempo e a seu único e exclusivo critério, estes Termos.`}}</p>
                        <p class="my-4">As alterações poderão impactar, inclusive, negociações já em andamento.</p>
                    </div>
                </div>
                <h6 class="c-nmidone d-block text-center regular mt-5 pb-3">
                    ©  {{actualYear}} Cashforce. Todos os direitos reservados. 
                </h6>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import NavbarDefault from '@/components/navigation/navbar/NavbarDefault'
import ArrowDropdown from '@/components/icons/ArrowDropdown'

import termsInfos from '@/views/policies/variables/termsInfo.js'
import termsInfosM7 from '@/views/policies/variables/termsInfoM7.js'
import legalInfos from './variables/legalPartnersInfos'
import getWhiteLabel from '../../utils/getWhiteLabel'

const dayjs = require('dayjs')
export default {
    components: {
        ArrowDropdown,
        NavbarDefault
    },
    data() {
    },
    computed: {
        actualYear() {
            return dayjs().year()
        },
        tableInfo() {
            return [
                { rowHead: "Versão", rowValue: "2.0" },
                { rowHead: "Data", rowValue: "04.09.2024" }
            ]
        },
        termsTopics() {
            return [
                "Definições",
                "Destinatários do Termo",
                "Da criação de Conta na Plataforma",
                "Do acesso à Plataforma",
                "Do uso pessoal e intransferível da Conta",
                "Da indisponibilidade total ou parcial da Plataforma",
                "Da limitação de responsabilidade",
                "Das responsabilidades do Fornecedor e do Usuário no uso da Plataforma",
                "Da propriedade intelectual",
                "Do tratamento de dados",
                "Do cancelamento da Conta",
                "Contato",
                "Legislação aplicável e foro de eleição",
            ]
        },
        getPartnerName() {
            if (!legalInfos[getWhiteLabel(true)]) {
                return legalInfos.cashforce.razaoSocial;
            } else {
                return legalInfos[getWhiteLabel(true)].razaoSocial;
            }
        },
        termsInfos() {
            if (getWhiteLabel(true) === 'm7' || getWhiteLabel(true) === 'universo') {
                return termsInfosM7
            } else {
                return termsInfos
            }
        }
    }, 
}
</script>

<style lang="scss">
@use '../../assets/scss/var' as *;
    
#terms-of-use-table {
    max-width: 767px!important;
    font-size: 14px;

    width: 100%;


    tr th,td {
        text-align: center!important;
        padding: 12px 32px!important;
        border: 1px solid $nmidfour!important;
        border-radius: 0;
        height: 50px;
    }

    .header-cell-style{
        text-align: center!important;
        border: 1px solid $nmidfour!important;
        padding-left: 0;
        background-color: $nlightone;
    }
    
    .el-table__row:first-of-type {
        td {
            padding-top: 40px!important
        }
    }
}
</style>
    